import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "star--empty",
  "use": "star--empty-usage",
  "viewBox": "0 0 18.61 17.7",
  "content": "<symbol viewBox=\"0 0 18.61 17.7\" id=\"star--empty\"><path class=\"cls-1\" d=\"M18.61 6.76l-6.43-.93L9.3 0 6.43 5.83 0 6.76l4.65 4.54-1.09 6.4 5.74-3 5.75 3L14 11.3zM12 11.63l.4 2.37-2.16-1.1-.94-.49-.93.49L6.21 14l.42-2.41.17-1-.8-.73-1.7-1.7 2.42-.35 1-.15.46-.95L9.3 4.52l1.09 2.19.46.95 1 .15 2.42.35-1.75 1.7-.75.74z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/star--empty.svg
// module id = 187
// module chunks = 0